<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path fill-rule="evenodd"
        d="M12 2.77a4.497 4.497 0 110 8.992 4.497 4.497 0 010-8.993zM3.435 19.941c-.88 0-1.364-1.004-.841-1.712 2.131-2.88 5.547-4.753 9.406-4.753 3.86 0 7.275 1.872 9.406 4.753.524.708.04 1.712-.841 1.712H3.435z"
        clip-rule="evenodd" />
</svg>